var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 3.85413C14.6158 3.85413 10.8905 5.39716 8.14391 8.14379C5.39729 10.8904 3.85425 14.6156 3.85425 18.5C3.85425 22.3843 5.39729 26.1095 8.14391 28.8561C10.8905 31.6028 14.6158 33.1458 18.5001 33.1458C22.3844 33.1458 26.1096 31.6028 28.8562 28.8561C31.6029 26.1095 33.1459 22.3843 33.1459 18.5C33.1459 14.6156 31.6029 10.8904 28.8562 8.14379C26.1096 5.39716 22.3844 3.85413 18.5001 3.85413Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4825 22.3819H24.2727L24.8678 18.5316H20.4818V16.4272C20.4818 14.8277 21.0044 13.4094 22.5006 13.4094H24.9048V10.0493C24.4824 9.99231 23.589 9.86743 21.9009 9.86743C18.3758 9.86743 16.3092 11.729 16.3092 15.9701V18.5316H12.6855V22.3819H16.3092V32.9647C17.0269 33.0726 17.7538 33.1458 18.4999 33.1458C19.1744 33.1458 19.8327 33.0842 20.4825 32.9963V22.3819Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.60375fe0.svg";
export { ForwardRef as ReactComponent };